import React from "react";
import { injectIntl } from "react-intl";
import LoginLayoutPP from "../login/LoginLayoutPP";
import { ClientLogo } from "@cxagroup/casper";
import LogoPP from "../common/LogoPP";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { camelizeKeys } from "humps";
import { compose } from "ramda";
import SetupTwoFAForm from "./SetupTwoFAForm";
import { sendOTPForm, get2FASettings, get2FACountryCodes } from "../../actions/loginActions";

const SetupTwoFAPagePP = props => {
  return (
    <LoginLayoutPP isFlex={true}>
        <div className="login__brand" style={{ width: "100%" }}>
          {props.logoUrl ? <ClientLogo client={props.client} logoUrl={props.logoUrl} size="large" /> : <LogoPP width={240}/>}
        </div>
        <div className="form-container-password">
          <SetupTwoFAForm pageName="2-Factor Authentication" onSubmit={props.sendOTPForm} {...props} />
        </div>
    </LoginLayoutPP>

  );
};

SetupTwoFAPagePP.propTypes = {
  logoUrl: PropTypes.string,
  client: PropTypes.string,
  sendOTPForm: PropTypes.func.isRequired,
};

const mapStateToProps = (
  {
    app: { client, clientName },
    common: { logoUrl, clientSettings },
    login: { otp, twoFACountryCodes, twoFASettings, twoFAEmailTokenError },
  },
  { query }
) => {
  const camelizeQuery = camelizeKeys(query);

  return {
    client,
    logoUrl,
    clientName,
    twoFASettings,
    twoFACountryCodes,
    otp,
    validationError: twoFAEmailTokenError,
    twoFaModes: clientSettings.twoFaModes,
    initialValues: {
      clientId: camelizeQuery.clientID,
      requestToken: camelizeQuery.token,
      countryCode: twoFASettings.countryName + twoFASettings.countryCode,
      mobileNo: twoFASettings.mobileNo,
    },
  };
};

const mapDispatchToProps = {
  sendOTPForm,
  get2FACountryCodes,
  get2FASettings,
};

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(SetupTwoFAPagePP);



// WEBPACK FOOTER //
// ./components/twoFA/SetupTwoFAPagePP.js